var map = {
	"./arrow_down.svg": 291,
	"./edit.svg": 292,
	"./github.svg": 293,
	"./heart.svg": 294,
	"./heart_on.svg": 295,
	"./reply.svg": 296,
	"./tip.svg": 297
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;


//////////////////
// WEBPACK FOOTER
// ./assets/icon !../node_modules/raw-loader ^\.\/.*\.svg$
// module id = 290
// module chunks = 0